export enum RequirementDetailsTabsEnum {
    GENERAL = 'GENERAL',
    FIXES = 'FIXES',
    CODE_CORRECTIONS = 'CODE_CORRECTIONS',
    DEVELOPMENT = 'DEVELOPMENT',
    TESTING = 'TESTING',
    RISK_ANALYSIS = 'RISK_ANALYSIS',
    DEFECTS = 'DEFECTS',
    APPROVALS = 'APPROVALS',
    ATTACHMENTS = 'ATTACHMENTS',
    COMMENTS = 'COMMENTS',
    HISTORY = 'HISTORY',
    LINKED_REQUIREMENTS = 'LINKED_REQUIREMENTS',
    TRANSPORTS = 'TRANSPORTS'
}
